<template>
  <div id="ReconciliationDetails">
      333
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>